"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTimeString = exports.getDayOfWeek = exports.readDate = exports.isDate = exports.generateDays = exports.createDay = void 0;
var strfTime_1 = __importDefault(require("./strfTime"));
var createDay = function () { return ({
    hours: __spreadArray([], __read(Array(24).keys())).map(function (r) { return ({
        value: 0,
        minutes: __spreadArray([], __read(Array(60).keys())).map(function (r) { return ({
            minute: r,
            data: {}
        }); })
    }); })
}); };
exports.createDay = createDay;
var generateDays = function () { return ({
    M: exports.createDay(), T: exports.createDay(), W: exports.createDay(),
    Th: exports.createDay(), F: exports.createDay(), Sa: exports.createDay(),
    Su: exports.createDay()
}); };
exports.generateDays = generateDays;
var isDate = function (val) {
    return typeof val.getMonth === 'function';
};
exports.isDate = isDate;
var readDate = function (val, adjustTimezone) {
    var date = new Date(val);
    if (adjustTimezone) {
        date = new Date((date.valueOf() - date.getTimezoneOffset() * 1000 * 60));
    }
    return date;
};
exports.readDate = readDate;
var weekday = new Array(7);
weekday[0] = "Monday";
weekday[1] = "Tuesday";
weekday[2] = "Wednesday";
weekday[3] = "Thursday";
weekday[4] = "Friday";
weekday[5] = "Saturday";
weekday[6] = "Sunday";
var getDayOfWeek = function (day) {
    return weekday[day];
};
exports.getDayOfWeek = getDayOfWeek;
var getTimeString = function (date) {
    return strfTime_1.default('%d - %H:%M', date);
};
exports.getTimeString = getTimeString;
